import {useLocalization} from "./localizationContext";
import {LocalizeProps} from "./types";

export const useLocalize = (): LocalizeProps => {
  const {localize, formatCurrency} = useLocalization();
  return {localize, formatCurrency};
};
